import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CommonModalStyle from "../../../styles/commonModalStyle";


export class CommonModal extends React.Component {
    render() {
        let { classes, modalOpen, ToggleModal, children, title, HandleGlobalValueChange } = this.props;
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={modalOpen}
                style={{ zIndex: 130 }}
                onClose={() => ToggleModal(false)}
                closeAfterTransition
                disableEnforceFocus
                BackdropComponent={() => <Backdrop id="backdrop-wrapper" onClick={_ => HandleGlobalValueChange && HandleGlobalValueChange({ value: true, type: 'commonModal', name: "isVideoFocused" })} style={{ visibility: "visible" }} />}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={modalOpen}>
                    <div id="common-modal-wrapper" data-app="common-modal-component-wrapper" onClick={_ => HandleGlobalValueChange && HandleGlobalValueChange({ value: false, type: 'commonModal', name: "isVideoFocused" })} className={classes.modalWrapper}>
                        <div className={classes.modalHeader}>{title}</div>
                        {children}
                    </div>
                </Fade>
            </Modal>
        )
    }
}


export default withStyles(CommonModalStyle)(CommonModal);
